import React from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

const useNavs = () => {

    const navigate = useNavigate()
    const { state } = useLocation()
    const { pathname } = useLocation()
    const { search } = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useParams()


    const GuestNav = (link) => {
        navigate(`/guest/${link}`)
    }
    const ProviderNav = (link) => {
        navigate(`/panel/provider/${link}`)
    }
    const BrokerNav = (link) => {
        navigate(`/panel/broker/${link}`)
    }
    const AccountManagerNav = (link) => {
        navigate(`/panel/account-manager/${link}`)
    }

    const setUrlParamItem = (key, value) => {
        const params = new URLSearchParams(searchParams);
        params.set(key, value);
        setSearchParams(params);
    }

    return (
        {
            GuestNav,
            ProviderNav,
            BrokerNav,
            AccountManagerNav,
            setUrlParamItem ,
            params,
            searchParams,
            search,
            navigate,
            pathname,
            state
        }
    )
}

export default useNavs